import { render } from "./FormInput.vue?vue&type=template&id=1c2ae82b&ts=true"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__